(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hb-promo-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hb-promo-bar')) {
    class HbPromoBar extends HTMLElement {
      connectedCallback() {
        this.design = window.Shopify?.designMode;
        this.endAt = this.resolveEnd();
        if (!this.endAt || this.endAt <= Date.now()) return this.finish();

        this.hidden = false;
        this.nums = ['days', 'hours', 'mins', 'secs'].map((key) => this.querySelector(`[data-${key}]`));
        this.visible = null;

        this.onScroll = () => {
          if (this.ticking) return;
          this.ticking = true;
          requestAnimationFrame(() => {
            this.ticking = false;
            this.update();
          });
        };
        this.onResize = () => {
          this.measureTrigger();
          this.update();
        };
        // Capture: on desktop the theme scrolls .page-wrapper, and scroll events do not bubble.
        window.addEventListener('scroll', this.onScroll, { passive: true, capture: true });
        window.addEventListener('resize', this.onResize);
        this.resizeObserver = new ResizeObserver(() => this.publishHeight());
        this.resizeObserver.observe(this);
        // The bar is parsed before the product gallery, so measure again once the page and its images are in.
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.onResize, { once: true });
        if (document.readyState !== 'complete') window.addEventListener('load', this.onResize, { once: true });

        this.measureTrigger();
        this.update();
        this.tick();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll, { capture: true });
        window.removeEventListener('resize', this.onResize);
        this.resizeObserver?.disconnect();
        clearTimeout(this.timer);
        document.documentElement.style.removeProperty('--hb-promo-h');
      }

      // Per visitor: first view + duration, kept across pages and visits. Changing the duration in the
      // editor uses a new key, so everyone starts again.
      resolveEnd() {
        const duration = Number(this.dataset.duration) * 1000;
        if (!duration) return null;
        if (this.design) return Date.now() + duration;
        const key = `hb-promo-end:${this.dataset.duration}`;
        let end = null;
        try {
          end = Number(localStorage.getItem(key)) || null;
          if (!end) {
            end = Date.now() + duration;
            localStorage.setItem(key, String(end));
          }
        } catch {
          end = Date.now() + duration;
        }
        return end;
      }

      // The element that scrolls the page: .page-wrapper on desktop, else the document.
      scrollTop() {
        const wrapper = document.querySelector('.page-wrapper');
        if (wrapper && wrapper.scrollHeight > wrapper.clientHeight + 1 && /auto|scroll/.test(getComputedStyle(wrapper).overflowY)) {
          return wrapper.scrollTop;
        }
        return window.scrollY;
      }

      // Where the bar starts to show: bottom of the first product gallery, else the pixel setting.
      measureTrigger() {
        const gallery = this.dataset.trigger === 'gallery' && document.querySelector('media-gallery');
        const fallback = Number(this.dataset.threshold) || 400;
        this.threshold = gallery ? gallery.getBoundingClientRect().bottom + this.scrollTop() : fallback;
      }

      update() {
        const show = this.design || this.scrollTop() > this.threshold;
        if (show === this.visible) return;
        this.visible = show;
        this.toggleAttribute('data-visible', show);
        this.publishHeight();
      }

      publishHeight() {
        const height = this.visible && !this.hidden ? Math.round(this.offsetHeight) : 0;
        document.documentElement.style.setProperty('--hb-promo-h', `${height}px`);
      }

      tick() {
        const left = Math.max(0, Math.floor((this.endAt - Date.now()) / 1000));
        if (left <= 0) return this.finish();
        const values = [Math.floor(left / 86400), Math.floor((left % 86400) / 3600), Math.floor((left % 3600) / 60), left % 60];
        values.forEach((value, i) => {
          const text = value < 10 ? `0${value}` : String(value);
          if (this.nums[i] && this.nums[i].textContent !== text) this.nums[i].textContent = text;
        });
        this.timer = setTimeout(() => this.tick(), 1000 - (Date.now() % 1000));
      }

      finish() {
        this.removeAttribute('data-visible');
        this.hidden = true;
        this.visible = false;
        document.documentElement.style.setProperty('--hb-promo-h', '0px');
        window.removeEventListener('scroll', this.onScroll, { capture: true });
        window.removeEventListener('resize', this.onResize);
        this.resizeObserver?.disconnect();
      }
    }

    customElements.define('hb-promo-bar', HbPromoBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
